import { type EntityType } from 'core/domain/EntityType'
import { type FullMode } from 'core/domain/Mode'

import { type BulkRate, isSubmitted, isRateExpired } from './BulkRate'
import { isQuoteExpired } from './Quote'
import { type Shipper } from './Shipper'

export type BulkSpotQuote = {
  allQuotesExpired: boolean
  allRatesSent: boolean
  carrier: {
    name: string
    email: string
    entityType?: EntityType
    id: number
    dot?: string
    mc?: string
    scac?: string
  }
  carrierName: string
  carrierEmail: string
  mode: FullMode
  numberShipments: number
  rates: Array<BulkRate>
  shipper: Shipper
  soonestBidDeadline?: Date
}

export function getExpiredRates(bulkSpotQuote?: BulkSpotQuote): Array<BulkRate> {
  if (!bulkSpotQuote) {
    return []
  }

  return bulkSpotQuote.rates.filter(
    rate => (isRateExpired(rate) || isQuoteExpired(rate.quote)) && !isSubmitted(rate)
  )
}

export function getPendingRates(bulkSpotQuote?: BulkSpotQuote): Array<BulkRate> {
  if (!bulkSpotQuote) {
    return []
  }

  return bulkSpotQuote.rates.filter(
    rate => !isRateExpired(rate) && !isQuoteExpired(rate.quote) && !isSubmitted(rate)
  )
}

export function getSubmittedRates(bulkSpotQuote?: BulkSpotQuote): Array<BulkRate> {
  if (!bulkSpotQuote) {
    return []
  }

  return bulkSpotQuote.rates.filter(rate => isSubmitted(rate))
}
